import React, { useState, useEffect } from "react";
import { FaIdCard } from "react-icons/fa";
import { MdHourglassEmpty, MdFormatListBulleted } from "react-icons/md";
import {
  HiOutlineDownload,
  HiOutlineLogin,
  HiOutlineShieldCheck,
  HiOutlineShoppingBag,
} from "react-icons/hi";
import SideBar from "../../../../components/Sidebar";
import LoadingScreen from "../../../../components/LoadingScreen/LoadingScreen";
import { useSubscriptionCheck } from "../../../../hooks/useSubscriptionCheck";
import SubscriptionDialog from "../../../../components/Dialogs/SubscriptionDialog";
import Swal from "sweetalert2";

import UtiPanCardService from "../../../../services/UtiPanCardService";
import storage from "../../../../utils/storage";

const UtiEwalletPanCard = () => {
  const [loading, setLoading] = useState(true);
  const [serviceStatus, setServiceStatus] = useState("");

  const { premiumStatus, showDialog, setShowDialog, checkSubscriptionStatus } =
    useSubscriptionCheck();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setLoading(true);
      await fetchServiceStatus();
      await checkSubscriptionStatus();
    } finally {
      setLoading(false);
    }
  };

  const fetchServiceStatus = async () => {
    try {
      const result = await UtiPanCardService.serviceStatus();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res?.status === "SUCCESS") {
        const status = (res?.data?.service_status || "")
          .toString()
          .trim()
          .toUpperCase();

        console.log("UTI SERVICE STATUS:", status);
        setServiceStatus(status);
      }

      if (res.message == "Unauthorized Access") {
        storage.clearStorage();
        window.location.href = "/";
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error",
      );
    }
  };

  // 🔐 SAME LOGIC AS NSDL
  const canAccessService = () => {
    if (serviceStatus === "ENABLED") return true;
    return premiumStatus === "true";
  };

  const handlePsaLoginGenerateUrl = async () => {
    try {
      setLoading(true);

      const result = await UtiPanCardService.ewalletGenerateUrl();

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res?.status === "SUCCESS") {
        const url = res?.data?.url;

        if (url) {
          window.open(url, "_blank", "noopener,noreferrer");
        } else {
          Swal.fire("Oops!", "URL not received.", "error");
        }
      } else {
        Swal.fire("Oops!", res?.message || "Failed to generate URL", "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const services = [
    {
      name: "Login to PSA Portal",
      icon: <HiOutlineLogin size={40} color="#0d6efd" />,
      action: handlePsaLoginGenerateUrl,
    },
    {
      name: "PAN Application Report",
      icon: <MdFormatListBulleted size={40} color="#0d6efd" />,
      href: "/uti-pancard/e-wallet/report",
    },
  ];

  return (
    <div>
      {loading && <LoadingScreen />}

      <div className="container-fluid mt-3">
        <div className="row">
          <SideBar />

          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-4">
                  UTIITSL E-Wallet PAN Card Services
                </h5>

                <div className="d-flex gap-4 flex-wrap justify-content-center">
                  {services.map((service, index) => (
                    <div
                      key={index}
                      className="border rounded p-4 text-center shadow-sm hover-effect"
                      style={{
                        width: "220px",
                        cursor: loading ? "not-allowed" : "pointer",
                        opacity: loading ? 0.6 : 1,
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => {
                        if (loading) return;

                        if (!canAccessService()) {
                          setShowDialog(true);
                          return;
                        }

                        if (service.action) {
                          service.action();
                        } else if (service.newTab) {
                          window.open(service.href, "_blank");
                        } else {
                          window.location.href = service.href;
                        }
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      <div className="mb-3">{service.icon}</div>
                      <div className="fw-medium" style={{ fontSize: "16px" }}>
                        {service.name}{" "}
                        {service.isNew && (
                          <span
                            className="badge bg-danger ms-2"
                            style={{ fontSize: "10px" }}
                          >
                            NEW
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SubscriptionDialog
        show={showDialog && serviceStatus !== "ENABLED"}
        onHide={() => setShowDialog(false)}
        serviceName="UTI PAN"
      />
    </div>
  );
};

export default UtiEwalletPanCard;
